module.exports = __webpack_public_path__ + "img/topimg.68b9185a.png";